export const REGION_PAYMENT_RATE_MIN = 0.01;
export const REGION_PAYMENT_RATE_MAX = 99.99;
export const REGION_COST_PER_BOARD_MIN = 0;

export const REGION_COST_PER_SQFT_MIN = 0;
